import { z } from "zod";
import { schemes } from "@zeal/common";

export const getPartnerBusinessDocumentUrlParamsSchema = z.object({
  whiteLabelID: schemes.uuid(),
  document_key: z.string().min(1),
});

export type TGetPartnerBusinessDocumentUrlParams = z.infer<
  typeof getPartnerBusinessDocumentUrlParamsSchema
>;

export const getPartnerBusinessDocumentUrlResponseSchema = z.object({
  url: z.string(),
});

export type TGetPartnerBusinessDocumentUrlResponse = z.infer<
  typeof getPartnerBusinessDocumentUrlResponseSchema
>;
